const getDefaultState = () => {
    return {
        group: {},
        project: {},
        currentProjectId: null,
        module: {},
        projectModule: {},
        hseContact: {},
        hseDocument: {},
        dashboard: {},
        currentDashboardId: null,
        projectUserSettings: {},
        groupUserSettings: {},
        hseDocumentUserSettings: {},
        location: [],
        user: {},
        company: {},
        widgetsData: {},
        addWidget: {},
        deleteWidget: {},
        showTagInterface: false,
    }
}

const state = getDefaultState()

const getters = {
    // GROUP
    groups(state: any) {
        return state.group
    },

    group: (state: any) => (id: string) => {
        return state.group[id]
    },

    projectPermissions: (state: any) => (projectId: string, contractorId: string) => {
        const project = state.project[projectId]
        if (!project) return []

        return [
            ...project.attributes.permissions,
            ...(project.attributes.contractorPermissions[contractorId] || []),
        ]
    },

    projectsGroupPermissions: (state: any) => (id: string) => {
        let permissions: Array<any> = []
        state.group[id].relationships.projects.data.map((project: any) => {
            permissions = [...permissions, ...state.project[project.id].attributes.permissions]
        })
        return permissions
    },

    // PROJECT
    projects(state: any) {
        return state.project
    },

    project: (state: any) => (id: string) => {
        return state.project[id]
    },

    // currentProjectId - for group view, when you can only show one project at a time
    currentProjectId(state: any) {
        return state.currentProjectId
    },

    // Dashboard
    dashboards(state: any) {
        return state.dashboard
    },

    dashboard: (state: any) => (id: string) => {
        return state.dashboard[id]
    },

    currentDashboardId(state: any) {
        return state.currentDashboardId
    },

    // WIDGET
    widgetsData(state: any) {
        return state.widgetsData
    },

    widgetData: (state: any) => (id: string) => {
        return state.widgetsData[id]
    },

    addWidget(state: any) {
        return state.addWidget
    },

    deleteWidget(state: any) {
        return state.deleteWidget
    },

    // MODULES
    modules(state: any) {
        return state.module
    },

    module: (state: any) => (id: string) => {
        return state.module[id]
    },

    // PROJECT MODULES
    projectModules(state: any) {
        return state.projectModule
    },

    projectModule: (state: any) => (id: string) => {
        return state.projectModule[id]
    },

    // HSE CONTACTS
    hseContacts(state: any) {
        return state.hseContact
    },

    hseContact: (state: any) => (id: string) => {
        return state.hseContact[id]
    },

    // HSE DOCUMENTS
    hseDocuments(state: any) {
        return state.hseDocument
    },

    hseDocument: (state: any) => (id: string) => {
        return state.hseDocument[id]
    },

    // SETTINGS
    projectUserSettings(state: any) {
        return state.projectUserSettings
    },

    projectUserSetting: (state: any) => (id: string) => {
        return state.projectUserSettings[id]
    },

    groupUserSettings(state: any) {
        return state.groupUserSettings
    },

    groupUserSetting: (state: any) => (id: string) => {
        return state.groupUserSettings[id]
    },

    // HSE DOCUMENTS USER SETTINGS
    hseDocumentsUserSettings(state: any) {
        return state.hseDocumentUserSettings
    },

    hseDocumentUserSettings: (state: any) => (id: string) => {
        return state.hseDocumentUserSettings[id]
    },

    // LOCATIONS
    projectLocations(state: any) {
        return state.location
    },

    projectLocation: (state: any) => (id: string) => {
        return state.location[id]
    },

    // USERS
    projectModuleUsers(state: any) {
        return state.user
    },

    projectModuleUser: (state: any) => (id: string) => {
        return state.user[id]
    },

    // COMPANY
    projectCompanies(state: any) {
        return state.company
    },

    projectCompany: (state: any) => (id: string) => {
        return state.company[id]
    },

    showTagInterface(state: any) {
        return state.showTagInterface
    },
}

const mutations = {
    // GROUP
    groups(state: any, payload: any) {
        state.group = payload
    },

    // PROJECT
    projects(state: any, payload: any) {
        state.project = payload
    },

    currentProjectId(state: any, payload: any) {
        state.currentProjectId = payload
    },

    // DASHBOARD
    dashboards(state: any, payload: any) {
        state.dashboard = payload
    },

    setCurrentDashboardId(state: any, payload: any) {
        state.currentDashboardId = payload
    },

    // WIDGET
    widgetsData(state: any, payload: any) {
        state.widgetsData = payload
    },

    widgetData(state: any, payload: any) {
        state.widgetsData = { ...state.widgetsData, ...payload }
    },

    addWidget(state: any, payload: any) {
        state.addWidget = payload
    },

    deleteWidget(state: any, payload: any) {
        state.deleteWidget = payload
    },

    // MODULE
    modules(state: any, payload: any) {
        state.module = payload
    },

    // PROJECT MODULE
    projectModules(state: any, payload: any) {
        state.projectModule = payload
    },

    projectModule(state: any, payload: any) {
        Object.assign(state.projectModule, { [payload.id]: payload })
        // state.projectModule = payload
    },

    // HSE CONTACTS
    hseContacts(state: any, payload: any) {
        state.hseContact = payload
    },

    // HSE DOCUMENTS
    hseDocuments(state: any, payload: any) {
        state.hseDocument = payload
    },

    // SETTINGS
    projectUserSettings(state: any, payload: any) {
        state.projectUserSettings = payload
    },

    groupUserSettings(state: any, payload: any) {
        state.groupUserSettings = payload
    },

    // HSE DOCUMENTS USER SETTINGS
    hseDocumentsUserSettings(state: any, payload: any) {
        state.hseDocumentUserSettings = payload
    },

    // LOCATION
    projectLocations(state: any, payload: any) {
        state.location = payload
    },

    // COMPANY
    projectCompanies(state: any, payload: any) {
        state.company = payload
    },

    // USER
    projectModuleUsers(state: any, payload: any) {
        state.user = payload
    },

    showTagInterface(state: any, payload: any) {
        state.showTagInterface = payload
    },

    //RESET
    resetProject(state: any) {
        const initial: any = getDefaultState()
        Object.keys(initial).forEach((key) => {
            state[key] = initial[key]
        })
    },
}

export default {
    state,
    getters,
    mutations,
}
